// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".materiaux[data-v-0a0c93c5]{height:30vh;overflow:scroll}", ""]);
// Exports
module.exports = exports;
